/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useCallback, useRef, useLayoutEffect} from 'react';
import {
  TableDefault,
  TableAverage,
  ShadowTableColumn,
  ShadowTableHead,
  ShadowSummaryColumn,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  StickyMainHeader,
  StickySubHeader,
  ChangeContainer,
  ArrowDownContainer,
  ArrowHolderSummary,
  ColumnContainerSummary,
  StickyShadowMainHeader,
  LoadSpace,
  ReportTableColumn,
  DownloadButton,
  FeatureLocked,
  TitleFeatureLocked,
  TextFeatureLocked,
} from './styles';
import {Radio, InputCheckbox, SelectPlayerColumn} from '..';
import Utils, {deepGet} from '../../utils/api/Utils';
import Admin from '../../utils/api/Admin';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import {capitalizeFirstLetters} from '../../utils/hooks/text-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import {Oval} from '../../pages/players/styles';
import {GoArrowDown, GoChevronDown, GoChevronUp} from 'react-icons/go';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({one: false, two: false});
  const [check, useCheck] = useState<any>({zone_1: false, zone_2: false, zone_3: false});

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }

    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = {one: true, two: false};
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = {one: false, two: true};
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px'}} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({...check, zone_1: !check.zone_1})} />
              <PopUpText onClick={() => useCheck({...check, zone_1: !check.zone_1})}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({...check, zone_2: !check.zone_2})} />
              <PopUpText onClick={() => useCheck({...check, zone_2: !check.zone_2})}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_3} onClick={() => useCheck({...check, zone_3: !check.zone_3})} />
              <PopUpText onClick={() => useCheck({...check, zone_3: !check.zone_3})}>Medical</PopUpText>
              <Oval size={'16'} color={'medical'} />
            </CheckBoxWrapper>
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}

export default ({
  dataTableContent,
  dataAverage,
  filter,
  dataCy,
  minWidth,
  fatigueZone,
  hidePlayer,
  sortBy,
  sortOrder,
  handleSort,
}: {
  dataTableContent: Array<any>;
  dataAverage: object | any;
  filter: string;
  minWidth?: string;
  dataCy?: string;
  team?: string;
  fatigueZone?: boolean;
  hidePlayer?: any;
  sortBy: string;
  sortOrder: string;
  handleSort: (column: string) => void;
}) => {
  const [table, setTable] = useState<Array<any>>(dataTableContent);
  const [popUp, usePopup] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(true);
  const ADMIN = new Admin();
  const UTILS = new Utils();

  useEffect(() => {
    setTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    setTable([...e]);
  }

  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }

  function changeStatus(change) {
    // Downward arrows hidden per requirements - logic preserved
    // if (change < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }

  async function DownloadDailyLog(player_id) {
    const fetchDailyLog = await ADMIN.GetDailyLog(player_id);
    const path = fetchDailyLog?.data?.report?.file?.path;
    if (path) {
      window.open(path, '_blank');
    }
  }

  async function DownloadReport(exam_id, firstname, lastname, date) {
    ADMIN.GetPlayerExamById(exam_id, firstname, 'Post_' + lastname, date);
  }

  function toggleSort(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, [!reverse, changeTable, table]);
  }

  function closeSorts() {
    usePopup('');
    useSort('');
  }

  return (
    <TableDefault data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          <StickyMainHeader>HIDE</StickyMainHeader>
          <StickyMainHeader onClick={() => handleSort('playerName')} style={{cursor: 'pointer'}}>
            PLAYERS {sortBy === 'playerName' && (sortOrder === 'asc' ? '▲' : '▼')}
          </StickyMainHeader>
          <StickyShadowMainHeader onClick={() => handleSort('date')} style={{cursor: 'pointer'}}>
            DATE {sortBy === 'date' && (sortOrder === 'asc' ? '▲' : '▼')}
          </StickyShadowMainHeader>
          <StickyMainHeader colSpan={3}>EVENT</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>TOTAL STRENGTH</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>INTERNAL ROTATION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>SCAPTION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>GRIP</StickyShadowMainHeader>
          <StickyMainHeader>REPORT</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <StickySubHeader onClick={() => handleSort('playerName')} style={{cursor: 'pointer'}}>
            <ColumnContainerSummary>
              <span>Name</span>
              <ArrowHolderSummary>
                {sortBy === 'playerName' && sortOrder === 'asc' && <GoChevronUp size={14} />}
                {sortBy === 'playerName' && sortOrder === 'desc' && <GoChevronDown size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </StickySubHeader>
          <ShadowTableHead onClick={() => handleSort('date')} style={{cursor: 'pointer'}}>
            <ColumnContainerSummary>
              <span>Sort Date</span>
              <ArrowHolderSummary>
                {sortBy === 'date' && sortOrder === 'asc' && <GoChevronUp size={14} />}
                {sortBy === 'date' && sortOrder === 'desc' && <GoChevronDown size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </ShadowTableHead>
          <StickySubHeader onClick={() => toggleSort('sortEventType', ['data', 'event', 'type'])}>
            <ColumnContainerSummary>
              <span>Type</span>
              <ArrowHolderSummary>
                {sort === 'sortEventType' && !reverse && <GoChevronUp size={14} />}
                {sort === 'sortEventType' && reverse && <GoChevronDown size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_2')}>Pitches</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'event', 'pitches']}
              popup_id={'pu_2'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_3')}>RPE</span>
            <PopUp table={dataTableContent} useTable={changeTable} data={['data', 'event', 'rpe']} popup_id={'pu_3'} visible={popUp} />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_4')}>% Fresh</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshTotalRatio']}
              popup_id={'pu_4'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'strength', 'armFatigueTotal']}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_5')}>Change (lbs)</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshTotalChange']}
              popup_id={'pu_5'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_6')}>% Fresh</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshIRRatio']}
              popup_id={'pu_6'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'strength', 'armFatigueIR']}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_7')}>Change (lbs)</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshIRChange']}
              popup_id={'pu_7'}
              visible={popUp}
            />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_8')}>% Fresh</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshERRatio']}
              popup_id={'pu_8'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'strength', 'armFatigueER']}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_9')}>Change (lbs)</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshERChange']}
              popup_id={'pu_9'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_10')}>% Fresh</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshScaptionRatio']}
              popup_id={'pu_10'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'strength', 'armFatigueScaption']}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_11')}>Change (lbs)</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshScaptionChange']}
              popup_id={'pu_11'}
              visible={popUp}
            />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_12')}>% Fresh</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshGripRatio']}
              popup_id={'pu_12'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'strength', 'armFatigueGrip']}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_13')}>Change (lbs)</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'strength', 'freshGripChange']}
              popup_id={'pu_13'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader />
        </tr>
      </thead>
      <tbody onClick={() => closeSorts()}>
        {table.length > 0 && (
          <tr className="tr-average">
            <td style={{borderLeft: '7px solid var(--PrimaryBlue)'}} />
            <td>
              <TableAverage>
                <LoadSpace>{loading && <Loader width="20px" color="#B1D6FF" />}</LoadSpace>
                Team Average:
              </TableAverage>
            </td>
            <ShadowSummaryColumn></ShadowSummaryColumn>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.strength?.freshTotalRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.strength?.freshTotalChange)}</ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.strength?.freshIRRatio, {digits: 0})}</td>
            <td>{numberColumnFormatter(dataAverage?.strength?.freshIRChange)}</td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.strength?.freshERRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.strength?.freshERChange)}</ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.strength?.freshScaptionRatio, {digits: 0})}</td>
            <td>{numberColumnFormatter(dataAverage?.strength?.freshScaptionChange)}</td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.strength?.freshGripRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.strength?.freshGripChange)}</ShadowSummaryColumn>
            <td></td>
          </tr>
        )}

        {table.length > 0 ? (
          table
            .filter(el => {
              const playerName: string = el?.player.firstName || '';
              const playerLast: string = el?.player.lastName || '';
              const name = `${playerName} ${playerLast}`;
              return name.toLocaleLowerCase().includes(filter.toLowerCase());
            })
            .map((item, index) => {
              item.data.alerts = item.data.alerts?.filter(alert => {
                if (alert === 'Pain') return true;
                else return false;
              });

              return (
                <TableItem
                  key={index}
                  item={item}
                  useLoading={setLoading}
                  fatigueZone={fatigueZone}
                  changeStatus={changeStatus}
                  DownloadDailyLog={DownloadDailyLog}
                  DownloadReport={DownloadReport}
                  hidePlayer={hidePlayer}
                />
              );
            })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, useLoading, fatigueZone, changeStatus, DownloadDailyLog, DownloadReport, hidePlayer}) => {
  const [hide, setHide] = useState<Boolean>(item.data.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.data.excludeFromExamAvg ? '0.5' : '1');
  const PlayerRef = useRef(0) as any;
  const hiddenRef = useRef(0) as any;
  const dateRef = useRef(0) as any;
  /** defines where the component should start that limits the basic functionalities */
  const [left, setLeft] = useState<number>(340);

  useLayoutEffect(() => {
    changeScreen();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    };
  }, []);

  const changeScreen = () => {
    setLeft(hiddenRef.current.offsetWidth + PlayerRef.current.offsetWidth + dateRef.current.offsetWidth + 19);
  };

  const handleHideToggle = useCallback(() => {
    setHide(prevHide => {
      const newHide = !prevHide;
      hidePlayer(item.player._id, newHide ? 'exclude' : 'include');
      useLoading(true);
      hide ? setOpacity('0.5') : setOpacity('1');
      return newHide;
    });
  }, [hidePlayer, item.player._id, useLoading]);

  return (
    <tr style={{opacity: opacity, position: 'relative'}}>
      <td className="white pointer" onClick={handleHideToggle} ref={hiddenRef}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOff" />}
      </td>
      <SelectPlayerColumn player={item.player} padding={'8px'} unClickeable={item.player.plan === 'basic'} PlayerColumnRef={PlayerRef} />
      <ShadowTableColumn ref={dateRef}>
        {(item.data.date && new Date(item.data.date).toLocaleDateString('en-US')) || '-'}
      </ShadowTableColumn>
      <td className="white">{item.player.plan !== 'basic' && capitalizeFirstLetters(item?.data?.event?.type, '_')}</td>
      <td className="white">
        {item.player.plan !== 'basic' && item?.data?.event?.type === 'velo_day'
          ? item?.data?.event?.highIntentsThrows
          : numberColumnFormatter(item?.data?.event?.pitches, {digits: 0})}
      </td>
      <td className="white">{(item.player.plan !== 'basic' && item?.data?.event?.rpe) || '-'}</td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshTotalRatio, {digits: 0})}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.strength.armFatigueTotal)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshTotalChange)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.strength.freshTotalChange)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshIRRatio, {digits: 0})}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.strength.armFatigueIR)}
      </td>
      <td className="white">
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshIRChange)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.strength.freshIRChange)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshERRatio, {digits: 0})}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.strength.armFatigueER)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshERChange)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.strength.freshERChange)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshScaptionRatio, {digits: 0})}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.strength.armFatigueScaption)}
      </td>
      <td className="white">
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshScaptionChange)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.strength.freshScaptionChange)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshGripRatio, {digits: 0})}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.strength.armFatigueGrip)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.strength.freshGripChange)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.strength.freshGripChange)}
        </ChangeContainer>
      </ShadowTableColumn>
      <ReportTableColumn>
        {item.player.plan !== 'basic' && item?.data?.enabledPDF && (
          <DownloadButton
            type="PDF"
            onClick={() =>
              !hide && DownloadReport(item?.data?.postExamId, item?.player?.firstName, item?.player?.lastName, item?.data?.date)
            }>
            ↓ PDF
          </DownloadButton>
        )}
      </ReportTableColumn>
      {item.player.plan === 'basic' && (
        <FeatureLocked left={left} right={19}>
          <TitleFeatureLocked>
            Basic Subscription
            <TextFeatureLocked>
              {' '}
              - Unlock this data by sponsoring the athlete or have the player purchase a premium subscription
            </TextFeatureLocked>
          </TitleFeatureLocked>
        </FeatureLocked>
      )}
    </tr>
  );
};
